import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import arthereumProvider from "../../../backend/ArthereumProvider";
import { PAGE_NAME } from "../../../types";
import LoadingIndicator from "../../components/LoadingIndicator";
import CommonButton from "../../components/CommonButton";
import CommonPageTitle from "../../components/CommonPageTitle";
import IconDisplay from "../../components/IconDisplay";
import TextField from "../../components/TextField";
import Text from "../../components/ThemedText";
import useThemeHook from "../../hooks/useThemeHook";
import { useTranslationHook } from "../../hooks/useTranslationHook";
import { actions } from "../../redux";
import { THEME_COLORS } from "../../themes/DarkLight";
import {
  LOCAL_STORAGE_DATA,
  LocalStorageController,
} from "../../utils/LocalStorageController";
import PageView from "../../components/PageView";
import ContinueWithPiNetworkButton from "../../components/ContinueWithPiNetworkButton";

type Props = {};

const OnboardingSignInPage = (props: Props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const getTranslationText = useTranslationHook();
  const [isLoading, setIsLoading] = useState(false);
  const theme = useThemeHook();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const signInWithEmail = async () => {
    try {
      if (isLoading) {
        return;
      }
      setIsLoading(true);
      console.log("sign in");

      const user = await arthereumProvider.signIn({
        path: "email",
        email,
        password,
      });
      console.log("user got");

      dispatch(actions.setActualUser(user));
      LocalStorageController.connect().storeData(
        LOCAL_STORAGE_DATA.SYSTEM_FULLY_INITIALIZED,
        "true"
      );
      LocalStorageController.connect().storeData(
        LOCAL_STORAGE_DATA.EMAIL,
        email
      );
      LocalStorageController.connect().storeData(
        LOCAL_STORAGE_DATA.PASSWORD,
        password
      );
      navigate(PAGE_NAME.HOME, { replace: true });
    } catch (error: any) {
      console.log(error?.message);
      if (error?.message === "Invalid credentials") {
        alert(getTranslationText("invalid_credentials"));
      } else {
        alert(getTranslationText("error"));
      }
    } finally {
      setIsLoading(false);
    }
  };

  function signUp(): void {
    navigate(PAGE_NAME.ONBOARDING_SIGN_UP);
  }

  return (
    <PageView>
      <div>
        <IconDisplay />
        <CommonPageTitle
          padding={0}
          title={getTranslationText("continue_with_email")}
        />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            width: "100%",
          }}
        >
          <TextField
            type={"email"}
            multiline={false}
            backgroundColor={THEME_COLORS[theme].component_background_color}
            text={email}
            placeHolder={getTranslationText("email")}
            setText={setEmail}
          ></TextField>
          <TextField
            type={"password"}
            backgroundColor={THEME_COLORS[theme].component_background_color}
            text={password}
            placeHolder={getTranslationText("password")}
            setText={setPassword}
          ></TextField>
          {isLoading && <LoadingIndicator />}
          <CommonButton
            white={null}
            color={null}
            onClickHandle={signInWithEmail}
            text={getTranslationText("sign_in")}
          ></CommonButton>
          <div style={{ height: "10px" }}></div>
          <ContinueWithPiNetworkButton
            action="sign_in"
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
          <div style={{ height: "10px" }}></div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              text=" Don't have an Account ? "
              style={{ textAlign: "center" }}
            />
            <p> </p>
            <Text
              onPress={signUp}
              text=" Sign Up Now"
              style={{ color: THEME_COLORS[theme].blue }}
            />
          </div>

          {/* <Tos /> */}
        </div>
      </div>
    </PageView>
  );
};

export default OnboardingSignInPage;
